import React, { useEffect } from "react";

function InstructionsPopup({ currentAssessmentId, setInstructionsPopup }) {
  const handleOpenAssessment = (currentAssessmentId) => {
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const newWindow = window.open(
      `/Assessment/pending/questions/${currentAssessmentId}`,
      "_blank",
      `width=${screenWidth}px,height=${screenHeight}px`
    );
    if (newWindow) {
      newWindow.addEventListener("beforeunload", () => {
        window?.location?.reload();
      })
    };
  };

  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess">
        <div className="d-flex justify-content-start gap-3 align-items-center">
          <img src="/StudentImg/BreathSchoolLogo.png" alt="icon"></img>
          <span className="sucessMsg20">Confirmation</span>
        </div>
        <div className=" mt-4">
          <p>[PLEASE READ BELOW CAREFULLY]</p>
          <p>
            1. After Starting the Assessment, Please DON'T Close Assessment
            Window.
          </p>
          <p>
            2. Assessment will automatically Close on Submission or Timer
            Expiry.
          </p>
          <p>
            3. On Timer Expiry, Assessment will automatically Submit in the
            existing state.
          </p>
          <p>
            4. You Won't Be Able To Enter Assessment Screen Again After Exit.
          </p>
        </div>
        <div>
          Do you want to Start Assessment Now?
        </div>
        <div className="d-flex justify-content-around align-items-center mt-5 widthOfContainer">
          <button className="okayBtnsucessBack" onClick={() => setInstructionsPopup(false)}>No</button>
          <button className="okayBtnsucess" onClick={() => {
            handleOpenAssessment(currentAssessmentId)
            setInstructionsPopup(false)
          }}>Yes</button>
        </div>
      </div>
    </div>
  );
}

export default InstructionsPopup;
